import { Routes, Route } from "react-router-dom";

import "./styles/main.css";

import Home from "./pages/home.js";
import Vote from "./pages/vote.js";

function App() {
  return (
    <Routes>
      <Route path="/vote" element={<Vote />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default App;
